import { cloneElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ButtonRadio } from '@/components'
// import ScalingSpecBilling from '@/pages/auto-scaling/components/ScalingSpecBilling.tsx'
// import ScalingSpecHistory from '@/pages/auto-scaling/components/ScalingSpecHistory.tsx'
import ScalingSpecMetric from '@/pages/auto-scaling/components/ScalingSpecMetric.tsx'
import ScalingSpecMonitor from '@/pages/auto-scaling/components/ScalingSpecMonitor.tsx'
import ScalingSpecTarget from '@/pages/auto-scaling/components/ScalingSpecTarget.tsx'
interface ScalingSpecDetailProp {
  scalingSpecResId: string
}

type Item = {
  label: string
  value: string
  Comp: JSX.Element
}

export default function ScalingSpecDetail({ scalingSpecResId }: ScalingSpecDetailProp) {
  const { t } = useTranslation()
  const targetItem = {
    label: t('scaling.scalingTargetLabel'),
    value: 'ScalingTarget',
    Comp: <ScalingSpecTarget scalingSpecResId={scalingSpecResId} />,
  }
  const metricItem = {
    label: t('scaling.loadMetricLabel'),
    value: 'LoadMetric',
    Comp: <ScalingSpecMetric scalingSpecResId={scalingSpecResId} />,
  }
  const monitorItem = {
    label: t('scaling.monitorLabel'),
    value: 'Monitor',
    Comp: <ScalingSpecMonitor scalingSpecResId={scalingSpecResId} />,
  }
  // const billingItem = { label: 'Billing', value: 'Billing', Comp: <ScalingSpecBilling /> }
  // const historyItem = {
  //   label: 'Scaling History',
  //   value: 'ScalingHistory',
  //   Comp: <ScalingSpecHistory />,
  // }

  const items: Item[] = [targetItem, metricItem, monitorItem].filter(Boolean) as Item[]

  const [tab, setTab] = useState(items[0].value)
  return (
    <div>
      <div className="px-4">
        <ButtonRadio
          className="mb-2 "
          value={tab}
          items={items}
          onChange={(e) => setTab(e)}
          size={'small'}
        />

        {items.map((item) => tab === item.value && cloneElement(item.Comp, { key: item.value }))}
      </div>
    </div>
  )
}
